import { useState, useCallback } from 'react'

const useObjState = (initialState = {}) => {
  const [state, _setState] = useState(initialState)

  const setState = useCallback(
    (obj) =>
      _setState((prevState) => {
        const nextState = typeof obj === 'function' ? obj(prevState) : obj
        return { ...prevState, ...nextState }
      }),
    [],
  )

  return [state, setState]
}

export default useObjState
